import { Box, Typography, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Icons
import GoogleIcon from "@mui/icons-material/Google";
import StarIcon from "@mui/icons-material/Star";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useSelector } from "react-redux";
import { mergeManagedContent } from "../../hooks/mergeManagedContent";
import { colors } from "../../theme/designTokens";

const ReviewBar = () => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));

  // Store
  const { webSettings } = useSelector((state) => state.webSettings);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { langs } = useSelector((state) => state.misc);

  const [contentSettings, setContentSettings] = useState([]);
  const [langId, setLangId] = useState("");

  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);

  // Set Settings
  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) {
        setContentSettings(M);
      }
    }
  }, [langId, managedContentSettings]);

  useEffect(() => {}, [webSettings]);
  return (
    <Box
      sx={{
        backgroundColor: colors.paperTint,
        borderBottom: `1px solid ${colors.line}`,
        py: 1.1,
        color: colors.ink2,
      }}
    >
      <Box sx={{ maxWidth: 1600, mx: "auto", px: { xs: 2, sm: 3 } }}>
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"space-evenly"}
      >
        {smUp && (
          <Grid item>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  bgcolor: colors.primaryLight,
                  color: colors.primary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <PhoneInTalkIcon sx={{ fontSize: 16 }} />
              </Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: 700, letterSpacing: "0.01em", color: colors.ink2 }}
              >
                {contentSettings.footerContactInfo &&
                contentSettings.footerContactInfo.contactNumber &&
                contentSettings.footerContactInfo.contactNumber.length > 0
                  ? contentSettings.footerContactInfo.contactNumber.join(", ")
                  : ""}
              </Typography>
            </Box>
          </Grid>
        )}

        <Grid item>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              cursor:
                webSettings?.googleReviewUrlElife?.length > 2
                  ? "pointer"
                  : "auto",
              borderRadius: 999,
              px: 1.5,
              py: 0.4,
              transition: "background-color 0.2s",
              "&:hover": {
                bgcolor:
                  webSettings?.googleReviewUrlElife?.length > 2
                    ? colors.primaryLight
                    : "transparent",
              },
            }}
            onClick={() =>
              webSettings?.googleReviewUrlElife?.length > 2
                ? window.open(webSettings.googleReviewUrlElife, "_blank")
                : null
            }
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                bgcolor: colors.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <GoogleIcon sx={{ fontSize: 18, color: colors.white }} />
            </Box>
            <Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: 700, lineHeight: 1.2, color: colors.ink }}
              >
                Google Reviews
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: colors.ink2 }}
                >
                  {webSettings.googleReviewCountElife}
                </Typography>
                <Box sx={{ display: "flex", lineHeight: 0 }}>
                  {[0, 1, 2, 3, 4].map((idx) => (
                    <StarIcon
                      key={idx}
                      sx={{ fontSize: 13, color: "#F5A623" }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      </Box>
    </Box>
  );
};

export default ReviewBar;
